'use client'

import { useLocale, useTranslations } from 'next-intl'
import React, { useMemo } from 'react'

import type { HotelDestinationSuggestion } from '../searchForm/hooks/useHotelSearchManager'
import DestinationSuggestionList, { DestinationSuggestionRow } from './destinationSuggestionList'

interface DestinationSuggestionListWrapperProps {
    suggestions: HotelDestinationSuggestion[]
    onSelect: (suggestion: HotelDestinationSuggestion) => void
}

/**
 * Shared destination results, used by both the desktop popper and the mobile
 * full-screen selector so the two entry points cannot drift apart.
 */
const DestinationSuggestionListWrapper: React.FC<DestinationSuggestionListWrapperProps> = ({
    suggestions,
    onSelect
}) => {
    const t = useTranslations('common')
    const locale = useLocale()

    const rows = useMemo<DestinationSuggestionRow[]>(
        () =>
            suggestions.map(suggestion => ({
                suggestion,
                // Only cities carry a count; a property row shows nothing on the trailing edge.
                countLabel:
                    suggestion.propertyCount === null
                        ? ''
                        : `${suggestion.propertyCount.toLocaleString(locale)} ${t('hotels')}`
            })),
        [suggestions, locale, t]
    )

    return <DestinationSuggestionList rows={rows} onSelect={onSelect} />
}

export { DestinationSuggestionListWrapper as DestinationSuggestionList }
export default DestinationSuggestionListWrapper
